import { Card, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import FormVendorField from '../../../FormFields/FormVendorField';
import FieldContainer from '../../../FormFields/FieldContainer';
import FormNumberField from '../../../FormFields/FormNumberField';
import FormButtonOptions from '../../../FormFields/FormButtonOptions';
import FormTitle from '../../../FormFields/FormTitle';
import { PHARMACY } from '../../../formQuestionsEnum';
import { FILE_TYPES } from '../../../formFileTypesEnum';
import { formCardStyle } from '../../../TransitionStyles';
import { OWNERSHIP_TYPES } from '../../../optionEnums';

PharmacyForm.propTypes = {
  permissions: PropTypes.object,
};

export default function PharmacyForm({ permissions }) {
  const [focusedField, setFocusedField] = useState(null);
  const ownershipTypesList = useSelector((state) => state.transitions.data.ownershipTypesList);
  const cartOwnershipOptions = ownershipTypesList.filter(
    (x) => x.value === OWNERSHIP_TYPES.PHARMACY || x.value === OWNERSHIP_TYPES.FACILITY
  );
  const showForm = Object.values(PHARMACY).some(({ id }) => id in permissions);

  return (
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Pharmacy
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          {PHARMACY.PHARMACY_VENDOR.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Pharmacy vendor', fieldType: 'title' }} />
              <FormVendorField
                fieldName={PHARMACY.PHARMACY_VENDOR.fieldName}
                fieldAttributes={{ isEditable: permissions[PHARMACY.PHARMACY_VENDOR.id] }}
                invoiceFileTypeId={FILE_TYPES.PHARMACY_VENDOR_INVOICE}
                contractFileTypeId={FILE_TYPES.PHARMACY_VENDOR_CONTRACT}
              />
            </Grid>
          )}
          {PHARMACY.PHARMACY_CONSULTANT_VENDOR.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Pharmacy consultant vendor', fieldType: 'title' }} />
              <FormVendorField
                fieldName={PHARMACY.PHARMACY_CONSULTANT_VENDOR.fieldName}
                fieldAttributes={{ isEditable: permissions[PHARMACY.PHARMACY_CONSULTANT_VENDOR.id] }}
                invoiceFileTypeId={FILE_TYPES.PHARMACY_CONSULTANT_VENDOR_INVOICE}
                contractFileTypeId={FILE_TYPES.PHARMACY_CONSULTANT_VENDOR_CONTRACT}
              />
            </Grid>
          )}
          {PHARMACY.NUMBER_OF_MED_CARTS.id in permissions && (
            <Grid item xs={12} md={3}>
              <FieldContainer>
                <FormTitle fieldAttributes={{ questionTitle: 'How many med carts are there?' }} />
                <FormNumberField
                  fieldName={PHARMACY.NUMBER_OF_MED_CARTS.fieldName}
                  focusedField={focusedField}
                  setFocusedField={setFocusedField}
                  fieldAttributes={{ isEditable: permissions[PHARMACY.NUMBER_OF_MED_CARTS.id] }}
                />
              </FieldContainer>
            </Grid>
          )}
          {PHARMACY.MED_CARTS_OWNERSHIP_TYPE_ID.id in permissions && (
            <Grid item xs={12} md={9}>
              <FieldContainer>
                <FormTitle
                  fieldAttributes={{ questionTitle: 'Are the med carts owned by the pharmacy or the facility?' }}
                />
                <FormButtonOptions
                  fieldName={PHARMACY.MED_CARTS_OWNERSHIP_TYPE_ID.fieldName}
                  fieldAttributes={{
                    isEditable: permissions[PHARMACY.MED_CARTS_OWNERSHIP_TYPE_ID.id],
                    options: cartOwnershipOptions,
                  }}
                />
              </FieldContainer>
            </Grid>
          )}
          {PHARMACY.NUMBER_OF_TREATMENT_CARTS.id in permissions && (
            <Grid item xs={12} md={3}>
              <FieldContainer>
                <FormTitle fieldAttributes={{ questionTitle: 'How many treatment carts are there?' }} />
                <FormNumberField
                  fieldName={PHARMACY.NUMBER_OF_TREATMENT_CARTS.fieldName}
                  focusedField={focusedField}
                  setFocusedField={setFocusedField}
                  fieldAttributes={{ isEditable: permissions[PHARMACY.NUMBER_OF_TREATMENT_CARTS.id] }}
                />
              </FieldContainer>
            </Grid>
          )}
          {PHARMACY.TREATMENT_CARTS_OWNERSHIP_TPYE_ID.id in permissions && (
            <Grid item xs={12} md={9}>
              <FieldContainer>
                <FormTitle
                  fieldAttributes={{ questionTitle: 'Are the treatment carts owned by the pharmacy or the facility?' }}
                />
                <FormButtonOptions
                  fieldName={PHARMACY.TREATMENT_CARTS_OWNERSHIP_TPYE_ID.fieldName}
                  fieldAttributes={{
                    isEditable: permissions[PHARMACY.TREATMENT_CARTS_OWNERSHIP_TPYE_ID.id],
                    options: cartOwnershipOptions,
                  }}
                />
              </FieldContainer>
            </Grid>
          )}
        </Grid>
      </Card>
    )
  );
}
